
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("70dwx", function(module, exports) {

$parcel$export(module.exports, "getRandomUniqueNumbers", () => $e8dce92e5ba25285$export$cbb224b90d3f0722);
function $e8dce92e5ba25285$export$cbb224b90d3f0722(count, min, max) {
    const numbers = [];
    while(numbers.length < count){
        const num = Math.floor(Math.random() * (max - min + 1)) + min;
        if (!numbers.includes(num)) numbers.push(num);
    }
    return numbers;
}

});

parcelRegister("hP5lc", function(module, exports) {

$parcel$export(module.exports, "default", () => $31aac6c4017c3883$export$2e2bcd8739ae039);

var $lyHkj = parcelRequire("lyHkj");

var $eFtsB = parcelRequire("eFtsB");

var $khzO9 = parcelRequire("khzO9");
class $31aac6c4017c3883$export$2e2bcd8739ae039 extends (0, $eFtsB.default) {
    constructor(sRadian, radian, onUpdate, onComp){
        super();
        const target = (0, $khzO9.shortestAngleDifference)(sRadian, radian) + sRadian;
        const a = {
            radian: sRadian
        };
        new (0, $lyHkj.default).Tween({
            ...a
        }).to({
            radian: target
        }, 1200).easing((0, $lyHkj.default).Easing.Linear.None).onUpdate((a)=>onUpdate(a.radian)).onComplete(()=>onComp()).start();
    }
}

});
parcelRegister("khzO9", function(module, exports) {

$parcel$export(module.exports, "shortestAngleDifference", () => $72df74fcee39458c$export$15665e440adacfed);
function $72df74fcee39458c$var$normalizeAngle(angle) {
    return (angle + Math.PI * 2) % (Math.PI * 2);
}
function $72df74fcee39458c$export$15665e440adacfed(from, to) {
    const a = $72df74fcee39458c$var$normalizeAngle(from);
    const b = $72df74fcee39458c$var$normalizeAngle(to);
    let diff = b - a;
    if (diff > Math.PI) diff -= Math.PI * 2;
    if (diff < -Math.PI) diff += Math.PI * 2;
    return diff;
}

});


parcelRegister("ahQvm", function(module, exports) {

$parcel$export(module.exports, "generateAngles", () => $0afc574e42603e3d$export$adec80d12bc0398e);

var $5ekDK = parcelRequire("5ekDK");

var $g7X8y = parcelRequire("g7X8y");
function $0afc574e42603e3d$export$adec80d12bc0398e(p, clockwise) {
    const { startRadian: startRadian, endRadian: endRadian } = (0, $5ekDK.default)(p.curr, p.prev, p.next);
    const degree = (0, $g7X8y.default)({
        startRadian: startRadian,
        endRadian: endRadian
    }, clockwise, false);
    return {
        startRadian: startRadian,
        endRadian: endRadian,
        degree: degree
    };
}

});
parcelRegister("g7X8y", function(module, exports) {

$parcel$export(module.exports, "default", () => $377d1a2d96ea3eb0$export$2e2bcd8739ae039);

var $2c2c0 = parcelRequire("2c2c0");
function $377d1a2d96ea3eb0$export$2e2bcd8739ae039({ startRadian: startRadian, endRadian: endRadian }, cClockwise, even = true) {
    let _angle = startRadian - endRadian;
    if (!cClockwise) _angle = endRadian - startRadian;
    let degree = Math.floor((0, $2c2c0.default)(_angle));
    degree = degree < 0 ? degree + 360 : degree;
    even && (degree = degree % 2 == 1 ? degree + 1 : degree);
    return degree;
}

});
parcelRegister("2c2c0", function(module, exports) {

$parcel$export(module.exports, "default", () => $0253ba8048e12397$export$2e2bcd8739ae039);
function $0253ba8048e12397$export$2e2bcd8739ae039(radian) {
    return radian * (180 / Math.PI);
}

});



parcelRegister("fbGgL", function(module, exports) {

$parcel$export(module.exports, "default", () => $e59d79bdeb13626a$export$2e2bcd8739ae039);

var $2hUu0 = parcelRequire("2hUu0");

var $2Msgp = parcelRequire("2Msgp");
class $e59d79bdeb13626a$export$2e2bcd8739ae039 {
    constructor(cCoord, tags){
        this.center = new (0, $2hUu0.default)("O");
        this.tags = [];
        this.updateCenter = ()=>this.center.updateCoord({
                x: this.cCoord.x + 21,
                y: this.cCoord.y + 21
            });
        this.setAllVisible = (visible)=>[
                this.center,
                ...this.tags
            ].forEach((pTag)=>pTag.visible = visible);
        this.cCoord = cCoord;
        this.tags = tags.map((tag)=>new (0, $2hUu0.default)(tag));
        this.updateCenter();
    }
    updateCoord(radians, radius) {
        const coords = (0, $2Msgp.default)(this.cCoord, radians, radius + 30);
        coords.forEach((coord, cI)=>this.tags[cI].updateCoord(coord));
    }
}

});

parcelRegister("l5XQj", function(module, exports) {

$parcel$export(module.exports, "default", () => $ecc2fbd6d7a64bc4$export$2e2bcd8739ae039);

var $83ZZo = parcelRequire("83ZZo");

var $9e8jK = parcelRequire("9e8jK");
class $ecc2fbd6d7a64bc4$export$2e2bcd8739ae039 extends $83ZZo.Container {
    constructor(title, style, handleFunc){
        super(), this.Layers = (0, $9e8jK.default).getInstance(), this.addToLayer = ()=>this.Layers.UI.addChild(this);
        this.style = style;
        this.titleText = title;
        this.handleFunc = handleFunc;
        this.addBg(style);
        this.addTitle(title, style.titleColor);
        this.handleEvents();
        this.addToLayer();
    }
    handleEvents() {
        this.interactive = true;
        this.cursor = "pointer";
        const pressedFunc = ()=>{
            this.drawBg(this.style, this.style.pressedColor);
            this.handleFunc();
        };
        this.on("mouseover", ()=>this.drawBg(this.style, this.style.hoverColor));
        this.on("mouseup", ()=>this.drawBg(this.style, this.style.hoverColor));
        this.on("mouseleave", ()=>this.drawBg(this.style, this.style.defaultColor));
        this.on("mousedown", ()=>pressedFunc());
        this.on("touchstart", ()=>pressedFunc());
        this.on("touchend", ()=>this.drawBg(this.style, this.style.defaultColor));
    }
    addTitle(title, color) {
        this.title = new $83ZZo.Text({
            text: title
        });
        this.title.style = {
            fill: color,
            fontSize: this.style.titleFontSize,
            wordWrap: true,
            wordWrapWidth: this.style.wordWrapWidth,
            align: "center"
        };
        this.title.anchor.set(.5);
        this.addChild(this.title);
    }
    addBg(style) {
        this.bg = new $83ZZo.Graphics();
        this.addChild(this.bg);
        this.drawBg(style, style.defaultColor);
    }
    drawBg(style, color) {
        this.bg.clear();
        this.bg.roundRect(-style.width / 2, -style.height / 2, style.width, style.height, style.borderRadius).stroke({
            width: 5,
            color: style.borderColor
        }).fill(color);
    }
    handleTitle(title, color) {
        this.titleText = title;
        this.title.text = title;
        this.title.style.fill = color;
    }
}

});

parcelRegister("hvh3T", function(module, exports) {

$parcel$export(module.exports, "default", () => $2aa69c007d28c008$export$2e2bcd8739ae039);

var $83ZZo = parcelRequire("83ZZo");

var $9e8jK = parcelRequire("9e8jK");

var $4xmXZ = parcelRequire("4xmXZ");
const $2aa69c007d28c008$var$BUTTON_X = 10;
class $2aa69c007d28c008$export$2e2bcd8739ae039 extends $83ZZo.Container {
    constructor(color, handleSwitch, isAddCon = false){
        super(), this.Layers = (0, $9e8jK.default).getInstance(), this.isActive = false, this.addToLayer = ()=>this.Layers.UI.addChild(this), this.getActive = ()=>this.isActive;
        this.handleSwitch = handleSwitch;
        this.greenBg = this.addBg(color);
        this.grayBg = this.addBg(0xDEDEDE);
        this.addButton(0xFFFFFF);
        this.addInteractivity();
        !isAddCon && this.addToLayer();
    }
    addBg(color) {
        const bgBound = {
            width: 40,
            height: 20
        };
        const bg = new $83ZZo.Graphics().clear().roundRect(-bgBound.width / 2, -bgBound.height / 2, bgBound.width, bgBound.height).fill(color);
        this.addChild(bg);
        return bg;
    }
    handleSwitchButton() {
        this.isActive = !this.isActive;
        this.handleSwitch(this.isActive);
        new (0, $4xmXZ.default)(this);
    }
    addInteractivity() {
        this.interactive = true;
        this.cursor = "pointer";
        this.on("mouseup", ()=>this.handleSwitchButton());
        this.on("touchend", ()=>this.handleSwitchButton());
    }
    setActive(v) {
        this.grayBg.alpha = this.isActive ? 1 - v : v;
        this.greenBg.alpha = this.isActive ? v : 1 - v;
        this.button.x = this.isActive ? 2 * $2aa69c007d28c008$var$BUTTON_X * v : 2 * $2aa69c007d28c008$var$BUTTON_X * (1 - v);
    }
    addButton(color) {
        this.button = new $83ZZo.Graphics().circle(-$2aa69c007d28c008$var$BUTTON_X, 0, 8).fill(color);
        this.addChild(this.button);
    }
}

});
parcelRegister("4xmXZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $17774a77c2e12c3a$export$2e2bcd8739ae039);

var $lyHkj = parcelRequire("lyHkj");

var $eFtsB = parcelRequire("eFtsB");
class $17774a77c2e12c3a$export$2e2bcd8739ae039 extends (0, $eFtsB.default) {
    constructor(Switcher){
        super();
        const alpha = 0;
        new (0, $lyHkj.default).Tween({
            alpha: alpha
        }).to({
            alpha: 1
        }, 500).easing((0, $lyHkj.default).Easing.Linear.None).onUpdate(({ alpha: alpha })=>{
            Switcher.setActive(alpha);
        }).start();
    }
}

});


parcelRegister("2qYgo", function(module, exports) {

$parcel$export(module.exports, "default", () => $39dba461b9d2aedd$export$2e2bcd8739ae039);
function $39dba461b9d2aedd$export$2e2bcd8739ae039(cCoord, cCircumPoint, aSide1, aSide2) {
    let angle = Math.atan2(cCircumPoint.y - cCoord.y, cCircumPoint.x - cCoord.x);
    if (angle < 0) angle += 2 * Math.PI;
    let start = aSide1;
    let end = aSide2;
    if (start < 0) start += 2 * Math.PI;
    if (end < 0) end += 2 * Math.PI;
    if (start <= end) return angle >= start && angle <= end;
    else return angle >= start || angle <= end;
}

});

parcelRegister("htSjE", function(module, exports) {

$parcel$export(module.exports, "getTextureBatchBindGroup", () => $e6d9114a2720969b$export$84c26df82650dc9b);

var $dcKRv = parcelRequire("dcKRv");

var $7Ix7i = parcelRequire("7Ix7i");
"use strict";
const $e6d9114a2720969b$var$cachedGroups = {};
function $e6d9114a2720969b$export$84c26df82650dc9b(textures, size, maxTextures) {
    let uid = 2166136261;
    for(let i = 0; i < size; i++){
        uid ^= textures[i].uid;
        uid = Math.imul(uid, 16777619);
        uid >>>= 0;
    }
    return $e6d9114a2720969b$var$cachedGroups[uid] || $e6d9114a2720969b$var$generateTextureBatchBindGroup(textures, size, uid, maxTextures);
}
function $e6d9114a2720969b$var$generateTextureBatchBindGroup(textures, size, key, maxTextures) {
    const bindGroupResources = {};
    let bindIndex = 0;
    for(let i = 0; i < maxTextures; i++){
        const texture = i < size ? textures[i] : (0, $7Ix7i.Texture).EMPTY.source;
        bindGroupResources[bindIndex++] = texture.source;
        bindGroupResources[bindIndex++] = texture.style;
    }
    const bindGroup = new (0, $dcKRv.BindGroup)(bindGroupResources);
    $e6d9114a2720969b$var$cachedGroups[key] = bindGroup;
    return bindGroup;
}

});

parcelRegister("e9jtq", function(module, exports) {

$parcel$export(module.exports, "CanvasPool", () => $31a4fb027e026d19$export$e56d0a06781accc9);

var $aY7HM = parcelRequire("aY7HM");

var $hVXXe = parcelRequire("hVXXe");
"use strict";
class $31a4fb027e026d19$export$62d9f0b8aada09d7 {
    constructor(canvasOptions){
        this._canvasPool = /* @__PURE__ */ Object.create(null);
        this.canvasOptions = canvasOptions || {};
        this.enableFullScreen = false;
    }
    /**
   * Creates texture with params that were specified in pool constructor.
   * @param pixelWidth - Width of texture in pixels.
   * @param pixelHeight - Height of texture in pixels.
   */ _createCanvasAndContext(pixelWidth, pixelHeight) {
        const canvas = (0, $aY7HM.DOMAdapter).get().createCanvas();
        canvas.width = pixelWidth;
        canvas.height = pixelHeight;
        const context = canvas.getContext("2d");
        return {
            canvas: canvas,
            context: context
        };
    }
    /**
   * Gets a Power-of-Two render texture or fullScreen texture
   * @param minWidth - The minimum width of the render texture.
   * @param minHeight - The minimum height of the render texture.
   * @param resolution - The resolution of the render texture.
   * @returns The new render texture.
   */ getOptimalCanvasAndContext(minWidth, minHeight, resolution = 1) {
        minWidth = Math.ceil(minWidth * resolution - 1e-6);
        minHeight = Math.ceil(minHeight * resolution - 1e-6);
        minWidth = (0, $hVXXe.nextPow2)(minWidth);
        minHeight = (0, $hVXXe.nextPow2)(minHeight);
        const key = (minWidth << 17) + (minHeight << 1);
        if (!this._canvasPool[key]) this._canvasPool[key] = [];
        let canvasAndContext = this._canvasPool[key].pop();
        if (!canvasAndContext) canvasAndContext = this._createCanvasAndContext(minWidth, minHeight);
        return canvasAndContext;
    }
    /**
   * Place a render texture back into the pool.
   * @param canvasAndContext
   */ returnCanvasAndContext(canvasAndContext) {
        const canvas = canvasAndContext.canvas;
        const { width: width, height: height } = canvas;
        const key = (width << 17) + (height << 1);
        canvasAndContext.context.clearRect(0, 0, width, height);
        this._canvasPool[key].push(canvasAndContext);
    }
    clear() {
        this._canvasPool = {};
    }
}
const $31a4fb027e026d19$export$e56d0a06781accc9 = new $31a4fb027e026d19$export$62d9f0b8aada09d7();

});

parcelRegister("bRPvq", function(module, exports) {

$parcel$export(module.exports, "AbstractRenderer", () => $7c1ba3270bd37f6d$export$58ab3ed211eed562);

var $36Ltv = parcelRequire("36Ltv");

var $gHh6O = parcelRequire("gHh6O");

var $d7k7b = parcelRequire("d7k7b");

var $2RIEa = parcelRequire("2RIEa");

var $fdcJR = parcelRequire("fdcJR");

var $1Ki8H = parcelRequire("1Ki8H");


var $9W01S = parcelRequire("9W01S");

var $anqU0 = parcelRequire("anqU0");

var $98bME = parcelRequire("98bME");
"use strict";
const $7c1ba3270bd37f6d$var$defaultRunners = [
    "init",
    "destroy",
    "contextChange",
    "resolutionChange",
    "resetState",
    "renderEnd",
    "renderStart",
    "render",
    "update",
    "postrender",
    "prerender"
];
const $7c1ba3270bd37f6d$var$_AbstractRenderer = class _AbstractRenderer extends (0, (/*@__PURE__*/$parcel$interopDefault($98bME))) {
    /**
   * Set up a system with a collection of SystemClasses and runners.
   * Systems are attached dynamically to this class when added.
   * @param config - the config for the system manager
   */ constructor(config){
        super();
        /** @internal */ this.uid = (0, $fdcJR.uid)("renderer");
        /** @internal */ this.runners = /* @__PURE__ */ Object.create(null);
        /** @internal */ this.renderPipes = /* @__PURE__ */ Object.create(null);
        this._initOptions = {};
        this._systemsHash = /* @__PURE__ */ Object.create(null);
        this.type = config.type;
        this.name = config.name;
        this.config = config;
        const combinedRunners = [
            ...$7c1ba3270bd37f6d$var$defaultRunners,
            ...this.config.runners ?? []
        ];
        this._addRunners(...combinedRunners);
        this._unsafeEvalCheck();
    }
    /**
   * Initialize the renderer.
   * @param options - The options to use to create the renderer.
   */ async init(options = {}) {
        const skip = options.skipExtensionImports === true ? true : options.manageImports === false;
        await (0, $gHh6O.loadEnvironmentExtensions)(skip);
        this._addSystems(this.config.systems);
        this._addPipes(this.config.renderPipes, this.config.renderPipeAdaptors);
        for(const systemName in this._systemsHash){
            const system = this._systemsHash[systemName];
            const defaultSystemOptions = system.constructor.defaultOptions;
            options = {
                ...defaultSystemOptions,
                ...options
            };
        }
        options = {
            ..._AbstractRenderer.defaultOptions,
            ...options
        };
        this._roundPixels = options.roundPixels ? 1 : 0;
        for(let i = 0; i < this.runners.init.items.length; i++)await this.runners.init.items[i].init(options);
        this._initOptions = options;
    }
    render(args, deprecated) {
        let options = args;
        if (options instanceof (0, $d7k7b.Container)) {
            options = {
                container: options
            };
            if (deprecated) {
                (0, $1Ki8H.deprecation)((0, $1Ki8H.v8_0_0), "passing a second argument is deprecated, please use render options instead");
                options.target = deprecated.renderTexture;
            }
        }
        options.target || (options.target = this.view.renderTarget);
        if (options.target === this.view.renderTarget) {
            this._lastObjectRendered = options.container;
            options.clearColor ?? (options.clearColor = this.background.colorRgba);
            options.clear ?? (options.clear = this.background.clearBeforeRender);
        }
        if (options.clearColor) {
            const isRGBAArray = Array.isArray(options.clearColor) && options.clearColor.length === 4;
            options.clearColor = isRGBAArray ? options.clearColor : (0, $36Ltv.Color).shared.setValue(options.clearColor).toArray();
        }
        if (!options.transform) {
            options.container.updateLocalTransform();
            options.transform = options.container.localTransform;
        }
        options.container.enableRenderGroup();
        this.runners.prerender.emit(options);
        this.runners.renderStart.emit(options);
        this.runners.render.emit(options);
        this.runners.renderEnd.emit(options);
        this.runners.postrender.emit(options);
    }
    /**
   * Resizes the WebGL view to the specified width and height.
   * @param desiredScreenWidth - The desired width of the screen.
   * @param desiredScreenHeight - The desired height of the screen.
   * @param resolution - The resolution / device pixel ratio of the renderer.
   */ resize(desiredScreenWidth, desiredScreenHeight, resolution) {
        const previousResolution = this.view.resolution;
        this.view.resize(desiredScreenWidth, desiredScreenHeight, resolution);
        this.emit("resize", this.view.screen.width, this.view.screen.height, this.view.resolution);
        if (resolution !== void 0 && resolution !== previousResolution) this.runners.resolutionChange.emit(resolution);
    }
    /**
   * Clears the render target.
   * @param options - The options to use when clearing the render target.
   * @param options.target - The render target to clear.
   * @param options.clearColor - The color to clear with.
   * @param options.clear - The clear mode to use.
   * @advanced
   */ clear(options = {}) {
        const renderer = this;
        options.target || (options.target = renderer.renderTarget.renderTarget);
        options.clearColor || (options.clearColor = this.background.colorRgba);
        options.clear ?? (options.clear = (0, $9W01S.CLEAR).ALL);
        const { clear: clear, clearColor: clearColor, target: target } = options;
        (0, $36Ltv.Color).shared.setValue(clearColor ?? this.background.colorRgba);
        renderer.renderTarget.clear(target, clear, (0, $36Ltv.Color).shared.toArray());
    }
    /** The resolution / device pixel ratio of the renderer. */ get resolution() {
        return this.view.resolution;
    }
    set resolution(value) {
        this.view.resolution = value;
        this.runners.resolutionChange.emit(value);
    }
    /**
   * Same as view.width, actual number of pixels in the canvas by horizontal.
   * @type {number}
   * @readonly
   * @default 800
   */ get width() {
        return this.view.texture.frame.width;
    }
    /**
   * Same as view.height, actual number of pixels in the canvas by vertical.
   * @default 600
   */ get height() {
        return this.view.texture.frame.height;
    }
    // NOTE: this was `view` in v7
    /**
   * The canvas element that everything is drawn to.
   * @type {environment.ICanvas}
   */ get canvas() {
        return this.view.canvas;
    }
    /**
   * the last object rendered by the renderer. Useful for other plugins like interaction managers
   * @readonly
   */ get lastObjectRendered() {
        return this._lastObjectRendered;
    }
    /**
   * Flag if we are rendering to the screen vs renderTexture
   * @readonly
   * @default true
   */ get renderingToScreen() {
        const renderer = this;
        return renderer.renderTarget.renderingToScreen;
    }
    /**
   * Measurements of the screen. (0, 0, screenWidth, screenHeight).
   *
   * Its safe to use as filterArea or hitArea for the whole stage.
   */ get screen() {
        return this.view.screen;
    }
    /**
   * Create a bunch of runners based of a collection of ids
   * @param runnerIds - the runner ids to add
   */ _addRunners(...runnerIds) {
        runnerIds.forEach((runnerId)=>{
            this.runners[runnerId] = new (0, $anqU0.SystemRunner)(runnerId);
        });
    }
    _addSystems(systems) {
        let i;
        for(i in systems){
            const val = systems[i];
            this._addSystem(val.value, val.name);
        }
    }
    /**
   * Add a new system to the renderer.
   * @param ClassRef - Class reference
   * @param name - Property name for system, if not specified
   *        will use a static `name` property on the class itself. This
   *        name will be assigned as s property on the Renderer so make
   *        sure it doesn't collide with properties on Renderer.
   * @returns Return instance of renderer
   */ _addSystem(ClassRef, name) {
        const system = new ClassRef(this);
        if (this[name]) throw new Error(`Whoops! The name "${name}" is already in use`);
        this[name] = system;
        this._systemsHash[name] = system;
        for(const i in this.runners)this.runners[i].add(system);
        return this;
    }
    _addPipes(pipes, pipeAdaptors) {
        const adaptors = pipeAdaptors.reduce((acc, adaptor)=>{
            acc[adaptor.name] = adaptor.value;
            return acc;
        }, {});
        pipes.forEach((pipe)=>{
            const PipeClass = pipe.value;
            const name = pipe.name;
            const Adaptor = adaptors[name];
            this.renderPipes[name] = new PipeClass(this, Adaptor ? new Adaptor() : null);
        });
    }
    destroy(options = false) {
        this.runners.destroy.items.reverse();
        this.runners.destroy.emit(options);
        Object.values(this.runners).forEach((runner)=>{
            runner.destroy();
        });
        this._systemsHash = null;
        this.renderPipes = null;
    }
    /**
   * Generate a texture from a container.
   * @param options - options or container target to use when generating the texture
   * @returns a texture
   */ generateTexture(options) {
        return this.textureGenerator.generateTexture(options);
    }
    /**
   * Whether the renderer will round coordinates to whole pixels when rendering.
   * Can be overridden on a per scene item basis.
   */ get roundPixels() {
        return !!this._roundPixels;
    }
    /**
   * Overridable function by `pixi.js/unsafe-eval` to silence
   * throwing an error if platform doesn't support unsafe-evals.
   * @private
   * @ignore
   */ _unsafeEvalCheck() {
        if (!(0, $2RIEa.unsafeEvalSupported)()) throw new Error("Current environment does not allow unsafe-eval, please use pixi.js/unsafe-eval module to enable support.");
    }
    /**
   * Resets the rendering state of the renderer.
   * This is useful when you want to use the WebGL context directly and need to ensure PixiJS's internal state
   * stays synchronized. When modifying the WebGL context state externally, calling this method before the next Pixi
   * render will reset all internal caches and ensure it executes correctly.
   *
   * This is particularly useful when combining PixiJS with other rendering engines like Three.js:
   * ```js
   * // Reset Three.js state
   * threeRenderer.resetState();
   *
   * // Render a Three.js scene
   * threeRenderer.render(threeScene, threeCamera);
   *
   * // Reset PixiJS state since Three.js modified the WebGL context
   * pixiRenderer.resetState();
   *
   * // Now render Pixi content
   * pixiRenderer.render(pixiScene);
   * ```
   * @advanced
   */ resetState() {
        this.runners.resetState.emit();
    }
};
/** The default options for the renderer. */ $7c1ba3270bd37f6d$var$_AbstractRenderer.defaultOptions = {
    /**
   * Default resolution / device pixel ratio of the renderer.
   * @default 1
   */ resolution: 1,
    /**
   * Should the `failIfMajorPerformanceCaveat` flag be enabled as a context option used in the `isWebGLSupported`
   * function. If set to true, a WebGL renderer can fail to be created if the browser thinks there could be
   * performance issues when using WebGL.
   *
   * In PixiJS v6 this has changed from true to false by default, to allow WebGL to work in as many
   * scenarios as possible. However, some users may have a poor experience, for example, if a user has a gpu or
   * driver version blacklisted by the
   * browser.
   *
   * If your application requires high performance rendering, you may wish to set this to false.
   * We recommend one of two options if you decide to set this flag to false:
   *
   * 1: Use the Canvas renderer as a fallback in case high performance WebGL is
   *    not supported.
   *
   * 2: Call `isWebGLSupported` (which if found in the utils package) in your code before attempting to create a
   *    PixiJS renderer, and show an error message to the user if the function returns false, explaining that their
   *    device & browser combination does not support high performance WebGL.
   *    This is a much better strategy than trying to create a PixiJS renderer and finding it then fails.
   * @default false
   */ failIfMajorPerformanceCaveat: false,
    /**
   * Should round pixels be forced when rendering?
   * @default false
   */ roundPixels: false
};
let $7c1ba3270bd37f6d$export$58ab3ed211eed562 = $7c1ba3270bd37f6d$var$_AbstractRenderer;

});
parcelRegister("gHh6O", function(module, exports) {

$parcel$export(module.exports, "loadEnvironmentExtensions", () => $73b7dba69a4e9a90$export$3b30260a318c769f);

var $cMikx = parcelRequire("cMikx");
"use strict";
const $73b7dba69a4e9a90$var$environments = [];
(0, $cMikx.extensions).handleByNamedList((0, $cMikx.ExtensionType).Environment, $73b7dba69a4e9a90$var$environments);
async function $73b7dba69a4e9a90$export$3b30260a318c769f(skip) {
    if (skip) return;
    for(let i = 0; i < $73b7dba69a4e9a90$var$environments.length; i++){
        const env = $73b7dba69a4e9a90$var$environments[i];
        if (env.value.test()) {
            await env.value.load();
            return;
        }
    }
}
async function $73b7dba69a4e9a90$export$72225172dd907279(add) {
    return $73b7dba69a4e9a90$export$3b30260a318c769f(!add);
}

});

parcelRegister("2RIEa", function(module, exports) {

$parcel$export(module.exports, "unsafeEvalSupported", () => $7aebd45fef6bbf9b$export$70c0711f29adc5cf);
"use strict";
let $7aebd45fef6bbf9b$var$unsafeEval;
function $7aebd45fef6bbf9b$export$70c0711f29adc5cf() {
    if (typeof $7aebd45fef6bbf9b$var$unsafeEval === "boolean") return $7aebd45fef6bbf9b$var$unsafeEval;
    try {
        const func = new Function("param1", "param2", "param3", "return param1[param2] === param3;");
        $7aebd45fef6bbf9b$var$unsafeEval = func({
            a: "b"
        }, "a", "b") === true;
    } catch (_e) {
        $7aebd45fef6bbf9b$var$unsafeEval = false;
    }
    return $7aebd45fef6bbf9b$var$unsafeEval;
}

});

parcelRegister("9W01S", function(module, exports) {

$parcel$export(module.exports, "CLEAR", () => $019d7ae2ae677ac1$export$6c4d37c7f376a1de);
"use strict";
var $019d7ae2ae677ac1$export$6c4d37c7f376a1de = /* @__PURE__ */ ((CLEAR2)=>{
    CLEAR2[CLEAR2["NONE"] = 0] = "NONE";
    CLEAR2[CLEAR2["COLOR"] = 16384] = "COLOR";
    CLEAR2[CLEAR2["STENCIL"] = 1024] = "STENCIL";
    CLEAR2[CLEAR2["DEPTH"] = 256] = "DEPTH";
    CLEAR2[CLEAR2["COLOR_DEPTH"] = 16640] = "COLOR_DEPTH";
    CLEAR2[CLEAR2["COLOR_STENCIL"] = 17408] = "COLOR_STENCIL";
    CLEAR2[CLEAR2["DEPTH_STENCIL"] = 1280] = "DEPTH_STENCIL";
    CLEAR2[CLEAR2["ALL"] = 17664] = "ALL";
    return CLEAR2;
})($019d7ae2ae677ac1$export$6c4d37c7f376a1de || {});

});

parcelRegister("anqU0", function(module, exports) {

$parcel$export(module.exports, "SystemRunner", () => $27d711bf58994fc3$export$ff5f2fe687fe3979);
"use strict";
class $27d711bf58994fc3$export$ff5f2fe687fe3979 {
    /**
   * @param name - The function name that will be executed on the listeners added to this Runner.
   */ constructor(name){
        this.items = [];
        this._name = name;
    }
    /* jsdoc/check-param-names */ /**
   * Dispatch/Broadcast Runner to all listeners added to the queue.
   * @param {...any} params - (optional) parameters to pass to each listener
   */ /* jsdoc/check-param-names */ emit(a0, a1, a2, a3, a4, a5, a6, a7) {
        const { name: name, items: items } = this;
        for(let i = 0, len = items.length; i < len; i++)items[i][name](a0, a1, a2, a3, a4, a5, a6, a7);
        return this;
    }
    /**
   * Add a listener to the Runner
   *
   * Runners do not need to have scope or functions passed to them.
   * All that is required is to pass the listening object and ensure that it has contains a function that has the same name
   * as the name provided to the Runner when it was created.
   *
   * Eg A listener passed to this Runner will require a 'complete' function.
   *
   * ```ts
   * import { Runner } from 'pixi.js';
   *
   * const complete = new Runner('complete');
   * ```
   *
   * The scope used will be the object itself.
   * @param {any} item - The object that will be listening.
   */ add(item) {
        if (item[this._name]) {
            this.remove(item);
            this.items.push(item);
        }
        return this;
    }
    /**
   * Remove a single listener from the dispatch queue.
   * @param {any} item - The listener that you would like to remove.
   */ remove(item) {
        const index = this.items.indexOf(item);
        if (index !== -1) this.items.splice(index, 1);
        return this;
    }
    /**
   * Check to see if the listener is already in the Runner
   * @param {any} item - The listener that you would like to check.
   */ contains(item) {
        return this.items.indexOf(item) !== -1;
    }
    /** Remove all listeners from the Runner */ removeAll() {
        this.items.length = 0;
        return this;
    }
    /** Remove all references, don't use after this. */ destroy() {
        this.removeAll();
        this.items = null;
        this._name = null;
    }
    /**
   * `true` if there are no this Runner contains no listeners
   * @readonly
   */ get empty() {
        return this.items.length === 0;
    }
    /**
   * The name of the runner.
   * @readonly
   */ get name() {
        return this._name;
    }
}

});


parcelRegister("AFJYy", function(module, exports) {

$parcel$export(module.exports, "ApplicationInitHook", () => $00c29f6d2290dcd3$export$918f3e4d2b801859);
$parcel$export(module.exports, "RendererInitHook", () => $00c29f6d2290dcd3$export$5fba6e443d2fb64);

var $cMikx = parcelRequire("cMikx");

var $a02t4 = parcelRequire("a02t4");
"use strict";
class $00c29f6d2290dcd3$export$918f3e4d2b801859 {
    static init() {
        globalThis.__PIXI_APP_INIT__?.(this, (0, $a02t4.VERSION));
    }
    static destroy() {}
}
/** @ignore */ $00c29f6d2290dcd3$export$918f3e4d2b801859.extension = (0, $cMikx.ExtensionType).Application;
class $00c29f6d2290dcd3$export$5fba6e443d2fb64 {
    constructor(renderer){
        this._renderer = renderer;
    }
    init() {
        globalThis.__PIXI_RENDERER_INIT__?.(this._renderer, (0, $a02t4.VERSION));
    }
    destroy() {
        this._renderer = null;
    }
}
/** @ignore */ $00c29f6d2290dcd3$export$5fba6e443d2fb64.extension = {
    type: [
        (0, $cMikx.ExtensionType).WebGLSystem,
        (0, $cMikx.ExtensionType).WebGPUSystem
    ],
    name: "initHook",
    priority: -10
};

});
parcelRegister("a02t4", function(module, exports) {

$parcel$export(module.exports, "VERSION", () => $840423e2c9afffc1$export$a4ad2735b021c132);

var $98bME = parcelRequire("98bME");
"use strict";
const $840423e2c9afffc1$export$dbafa72958753fce = /^\s*data:(?:([\w-]+)\/([\w+.-]+))?(?:;charset=([\w-]+))?(?:;(base64))?,(.*)/i;
const $840423e2c9afffc1$export$a4ad2735b021c132 = "8.10.1";

});



var $d55ji = parcelRequire("d55ji");

var $d55ji = parcelRequire("d55ji");

var $83ZZo = parcelRequire("83ZZo");
var $f3fd8d4ca6003f65$export$cb883390c27ec6dd = /*#__PURE__*/ function(EnumEventBus) {
    EnumEventBus["startIntroAnim"] = "START_INTRODUCTION_ANIMATION";
    EnumEventBus["drawElements"] = "DRAW_ELEMENTS";
    EnumEventBus["setSltdTPIndex"] = "SET_SELECTED_TANGENT_POINT_INDEX";
    EnumEventBus["genRndmTriangle"] = "GENERATE_RANDOM_TRIANGLE";
    EnumEventBus["quasimodoMode"] = "QUASIMODO_MODE";
    EnumEventBus["moveTangentPoint"] = "MOVE_TANGENT_POINT";
    EnumEventBus["moveAllPoints"] = "MOVE_ALL_POINTS";
    EnumEventBus["setRefPoints"] = "SET_REF_POINTS";
    return EnumEventBus;
}({});
const $f3fd8d4ca6003f65$export$5087227eb54526 = new (0, $83ZZo.EventEmitter)();


const $60b5c7ab3382b5f8$export$c7609d9da8d80867 = {
    x: 600,
    y: 390
};
const $60b5c7ab3382b5f8$export$2bf7a7762037fddc = [
    Math.PI / 2,
    Math.PI * 9 / 8,
    -Math.PI / 8
];
const $60b5c7ab3382b5f8$export$ca8f2c484d507a5d = 200;
const $60b5c7ab3382b5f8$export$158208f930a33a87 = {
    x: 100,
    y: 20
};
const $60b5c7ab3382b5f8$export$e7d0c45026efed5d = {
    x: 100,
    y: 60
};
const $60b5c7ab3382b5f8$export$1312ecbb29a79419 = {
    x: 250,
    y: 800
};
const $60b5c7ab3382b5f8$export$186dbbe504e85fe1 = [
    {
        x: 450,
        y: 800
    },
    {
        x: 810,
        y: 800
    }
];
const $60b5c7ab3382b5f8$export$75f2cc8245aafe09 = [
    {
        x: 60,
        y: 420
    },
    {
        x: 60,
        y: 600
    }
];
const $60b5c7ab3382b5f8$export$840ec2322406bfdd = {
    x: 1180,
    y: 200
};
const $60b5c7ab3382b5f8$export$190b4c043fb6edf4 = {
    x: 1500,
    y: 800
};
const $60b5c7ab3382b5f8$export$7a003cdef7722780 = [
    0xFC99C4,
    0xF94F6F
];
const $60b5c7ab3382b5f8$export$301500ed3a742f63 = [
    0x21D4FE,
    0x0195B8
];
const $60b5c7ab3382b5f8$export$321ead0620a8fedc = [
    0xB5A1FF,
    0x95A1DF
];
const $60b5c7ab3382b5f8$export$9c42f2d310db4e52 = [
    $60b5c7ab3382b5f8$export$301500ed3a742f63[1],
    $60b5c7ab3382b5f8$export$7a003cdef7722780[1],
    0x000000
];
const $60b5c7ab3382b5f8$export$c6fbe3a520aa2995 = {
    x: 120,
    y: 250
};
const $60b5c7ab3382b5f8$export$4697ad01a4a84996 = [
    "/circle-theorem-3/info-slider/1.png",
    "/circle-theorem-3/info-slider/2.png",
    "/circle-theorem-3/info-slider/3.png",
    "/circle-theorem-3/info-slider/4.png",
    "/circle-theorem-3/info-slider/5.png",
    "/circle-theorem-3/info-slider/6.png",
    "/circle-theorem-3/info-slider/7.png",
    "/circle-theorem-3/info-slider/8.png",
    "/circle-theorem-3/info-slider/9.png",
    "/circle-theorem-3/info-slider/10.png",
    "/circle-theorem-3/info-slider/11.png",
    "/circle-theorem-3/info-slider/12.png"
];
const $60b5c7ab3382b5f8$export$80701b8f8598becf = [
    "/circle-theorem-3/quasimodo/head.png",
    "/circle-theorem-3/quasimodo/foot.png",
    "/circle-theorem-3/quasimodo/corkscrew.png"
];
const $60b5c7ab3382b5f8$export$a310f85340477585 = [
    ...$60b5c7ab3382b5f8$export$80701b8f8598becf,
    ...$60b5c7ab3382b5f8$export$4697ad01a4a84996
];



var $er2zg = parcelRequire("er2zg");
function $b1620ce7a9a602f5$export$72dbddf526f8a6f(cPoint, cirPoint, lenght) {
    const r = Math.atan2(cirPoint.y - cPoint.y, cirPoint.x - cPoint.x);
    const t = (0, $er2zg.normalizeRadian)(r + Math.PI / 2);
    const generatePoint = (l)=>({
            x: cirPoint.x + Math.cos(t) * l,
            y: cirPoint.y + Math.sin(t) * l
        });
    return [
        generatePoint(-lenght / 2),
        generatePoint(lenght / 2)
    ];
}



var $70dwx = parcelRequire("70dwx");

var $kOFqu = parcelRequire("kOFqu");

var $a9Ugo = parcelRequire("a9Ugo");

var $aZDOo = parcelRequire("aZDOo");

var $hP5lc = parcelRequire("hP5lc");
function $b990f86cfa82e252$export$7e0882271c304db0(circle, targetRadian, radianIndex, isClockwise, coord) {
    return new Promise((resolve)=>new (0, $kOFqu.default)(circle, targetRadian, radianIndex, isClockwise, coord, ()=>resolve()));
}
function $b990f86cfa82e252$export$720cbfe21b054bd1(line, from, to) {
    line.visible = true;
    return new Promise((resolve)=>new (0, $a9Ugo.default)(line, from, to, resolve));
}
function $b990f86cfa82e252$export$2707a00551b9d1cc(angle, value) {
    return new Promise((resolve)=>{
        angle.visible = true;
        angle.scale.set(0.3);
        new (0, $aZDOo.default)(angle, ()=>{
            angle.AngleValue.setValue(value);
            angle.AngleValue.visible = true;
            resolve();
        });
    });
}
function $b990f86cfa82e252$export$2798021cc33f6214(PointManager, tRadians) {
    const redPoints = PointManager.getRedPoints();
    const sRadians = PointManager.getRadians();
    return new Promise((resolve)=>{
        redPoints.forEach((redPoint, rI)=>{
            return $b990f86cfa82e252$export$6927aa2d8fee9fc5(sRadians[rI], tRadians[rI], (radian)=>PointManager.setRadian([
                    {
                        pTag: redPoint.tag,
                        radian: radian
                    }
                ]), ()=>resolve());
        });
    });
}
function $b990f86cfa82e252$export$6927aa2d8fee9fc5(sRadian, tRadian, callback, onComp = ()=>{}) {
    return new Promise((resolve)=>new (0, $hP5lc.default)(sRadian, tRadian, (radian)=>callback(radian), ()=>{
            onComp();
            resolve();
        }));
}


function $f6f16da075944ed1$export$4777bb8a9f19b87(PointManager) {
    const newRadians = (0, $70dwx.getRandomUniqueNumbers)(3, 0, 5).sort((a, b)=>a - b);
    newRadians.map((v)=>v * (Math.PI / 3)).sort().reverse();
    (0, $b990f86cfa82e252$export$2798021cc33f6214)(PointManager, newRadians);
}



var $2wguv = parcelRequire("2wguv");
class $dc934d77cbe07438$export$2e2bcd8739ae039 extends (0, $2wguv.default) {
    constructor(cCoord){
        super(cCoord, (0, $60b5c7ab3382b5f8$export$ca8f2c484d507a5d), (0, $60b5c7ab3382b5f8$export$2bf7a7762037fddc)), this.EventBus = (0, $f3fd8d4ca6003f65$export$5087227eb54526), this.tangent = [], this.sltdTPIndex = 0 // selected Tangent Point Index
        , this.getTangentCoords = ()=>this.tangent, this.getSltdTPointIndex = ()=>this.sltdTPIndex, this.generateRandomShape = ()=>(0, $f6f16da075944ed1$export$4777bb8a9f19b87)(this);
        this.setCoord();
        this.draw();
        this.EventBus.on((0, $f3fd8d4ca6003f65$export$cb883390c27ec6dd).genRndmTriangle, ()=>this.generateRandomShape());
        this.EventBus.on((0, $f3fd8d4ca6003f65$export$cb883390c27ec6dd).moveTangentPoint, (v)=>this.moveTangentPoint(v));
        this.EventBus.on((0, $f3fd8d4ca6003f65$export$cb883390c27ec6dd).moveAllPoints, (v)=>this.moveAllPoints(v));
        this.EventBus.on((0, $f3fd8d4ca6003f65$export$cb883390c27ec6dd).setRefPoints, ()=>this.pointRefRadians = [
                ...this.pointRadians
            ]);
        this.EventBus.on((0, $f3fd8d4ca6003f65$export$cb883390c27ec6dd).setSltdTPIndex, (index)=>{
            this.sltdTPIndex = index;
            this.setCoord();
        });
    }
    moveTangentPoint(v) {
        const tangentPoint = this.getRedPoints()[this.sltdTPIndex];
        const radian = this.pointRefRadians[this.sltdTPIndex] + v / 100 * (Math.PI / 3);
        this.setRadian([
            {
                pTag: tangentPoint.tag,
                radian: radian
            }
        ], true);
    }
    moveAllPoints(v) {
        const pointInfoArr = [
            ...this.getRedPoints()
        ].map((p, pI)=>{
            const radian = this.pointRefRadians[pI] + v / 100 * (Math.PI / 3);
            return {
                pTag: p.tag,
                radian: radian
            };
        });
        this.setRadian(pointInfoArr, true);
    }
    setCoord() {
        const tPointCoord = this.getRedPointsCoord()[this.sltdTPIndex];
        this.tangent = (0, $b1620ce7a9a602f5$export$72dbddf526f8a6f)(this.cCoord, tPointCoord, 300);
        this._setCoord();
    }
}



var $etsqE = parcelRequire("etsqE");


class $69464e1b4eaec9ae$export$2e2bcd8739ae039 {
    constructor(colors){
        this.EventBus = (0, $f3fd8d4ca6003f65$export$5087227eb54526);
        this.triangle = [
            new (0, $etsqE.default)(),
            new (0, $etsqE.default)(),
            new (0, $etsqE.default)()
        ];
        this.tangent = new (0, $etsqE.default)({
            color: (0, $60b5c7ab3382b5f8$export$321ead0620a8fedc)[0]
        });
        this.ishownSecondSegment = true;
        this.showPink = true;
        this.setAllVisible = (status)=>[
                this.tangent,
                ...this.triangle
            ].forEach((l)=>l.visible = status);
        this.setIsShowSecondSegment = (status)=>this.ishownSecondSegment = status;
        this.colors = colors;
        this.EventBus.on((0, $f3fd8d4ca6003f65$export$cb883390c27ec6dd).quasimodoMode, (v)=>this.showPink = !v);
    }
    draw(points, tPoints, sltdTPIndex) {
        const sI = sltdTPIndex;
        const prevI = sI != 0 ? sI - 1 : points.length - 1;
        this.triangle.forEach((line, lI)=>{
            line.setLineColor(lI == sI ? this.showPink ? this.colors[1] : 0x000000 : lI == prevI && this.ishownSecondSegment ? this.colors[0] : 0x000000);
            line.draw(points[lI], points[points.length == lI + 1 ? 0 : lI + 1]);
        });
        this.tangent.draw(tPoints[0], tPoints[1]);
    }
}



var $9e8jK = parcelRequire("9e8jK");

var $9NMk5 = parcelRequire("9NMk5");


var $elBkP = parcelRequire("elBkP");
function $c6d8c04060cd5dd9$export$73935091fa556468(angle, aPms, clockwise) {
    const smllDistance = Math.min((0, $elBkP.default)(aPms.points.curr, aPms.points.prev), (0, $elBkP.default)(aPms.points.curr, aPms.points.next));
    angle.smallDistance = Math.floor(smllDistance);
    angle.draw(aPms.points.curr, aPms.startRadian, aPms.endRadian, aPms.degree, clockwise);
    angle.x = aPms.points.curr.x;
    angle.y = aPms.points.curr.y;
    angle.rotation = 0;
}


function $ba0ab9ea16a15b58$export$5f61282e9abe72d5(points) {
    return [
        {
            curr: points[0],
            prev: points[2],
            next: points[1]
        },
        {
            curr: points[1],
            prev: points[0],
            next: points[2]
        },
        {
            curr: points[2],
            prev: points[1],
            next: points[0]
        }
    ];
}


function $1fce1050ac5b8010$export$102b20725d4d2263(coordArr1, coordArr2) {
    if (coordArr1.length !== coordArr2.length) return false;
    return coordArr1.every((point, index)=>{
        const other = coordArr2[index];
        return point.x === other.x && point.y === other.y;
    });
}



var $ahQvm = parcelRequire("ahQvm");

class $fb830ff0290f258a$export$2e2bcd8739ae039 {
    constructor(){
        this.Layers = (0, $9e8jK.default).getInstance();
        this.EventBus = (0, $f3fd8d4ca6003f65$export$5087227eb54526);
        this.circumAnglePink = new (0, $9NMk5.default)("circumPink", {
            color: (0, $60b5c7ab3382b5f8$export$7a003cdef7722780)[0],
            textColor: (0, $60b5c7ab3382b5f8$export$7a003cdef7722780)[1]
        });
        this.circumAngleBlue = new (0, $9NMk5.default)("circumBlue", {
            color: (0, $60b5c7ab3382b5f8$export$301500ed3a742f63)[0],
            textColor: (0, $60b5c7ab3382b5f8$export$301500ed3a742f63)[1]
        });
        this.alternativeAnglePink = new (0, $9NMk5.default)("alternativePink", {
            color: (0, $60b5c7ab3382b5f8$export$7a003cdef7722780)[0],
            textColor: (0, $60b5c7ab3382b5f8$export$7a003cdef7722780)[1]
        }, 10, true);
        this.alternativeAngleBlue = new (0, $9NMk5.default)("alternativeBlue", {
            color: (0, $60b5c7ab3382b5f8$export$301500ed3a742f63)[0],
            textColor: (0, $60b5c7ab3382b5f8$export$301500ed3a742f63)[1]
        }, 10, true);
        this.isShownSecondSegment = true;
        this.currPoints = [];
        this.currDegrees = [];
        this.Layers.Top.addChild(this.alternativeAnglePink);
        this.Layers.Top.addChild(this.alternativeAngleBlue);
        this.EventBus.on((0, $f3fd8d4ca6003f65$export$cb883390c27ec6dd).quasimodoMode, (v)=>this.setIsShownSecondSegment(v));
    }
    setAllVisible(status) {
        [
            this.circumAnglePink,
            this.alternativeAnglePink,
            this.circumAngleBlue,
            this.alternativeAngleBlue
        ].forEach((angle)=>angle.setVisible(status));
    }
    setIsShownSecondSegment(v) {
        this.isShownSecondSegment = !v;
        [
            this.circumAnglePink,
            this.alternativeAnglePink
        ].forEach((angle)=>{
            angle.visible = !v;
            angle.AngleValue.visible = !v;
        });
    }
    draw(points, tangentCoords, sltdTPIndex, clockwise) {
        const sI = sltdTPIndex;
        const pL = points.length;
        const bI = sI != pL - 1 ? sI + 1 : 0;
        const pI = sI != 0 ? sI - 1 : pL - 1;
        const angleParams = this.generateAngleParams(points.map((p)=>({
                x: p.x,
                y: p.y
            })), sI, clockwise);
        const blueP = {
            curr: points[sI],
            prev: tangentCoords[clockwise ? 0 : 1],
            next: points[pI]
        };
        const blueDetail = (0, $ahQvm.generateAngles)(blueP, !clockwise);
        const alternatifParamsB = {
            startRadian: blueDetail.startRadian,
            endRadian: blueDetail.endRadian,
            degree: angleParams[bI].degree,
            points: blueP
        };
        (0, $c6d8c04060cd5dd9$export$73935091fa556468)(this.circumAngleBlue, angleParams[bI], clockwise);
        (0, $c6d8c04060cd5dd9$export$73935091fa556468)(this.alternativeAngleBlue, alternatifParamsB, clockwise);
        if (this.isShownSecondSegment) {
            const pinkP = !clockwise ? {
                curr: points[sI],
                prev: tangentCoords[0],
                next: points[bI]
            } : {
                curr: points[sI],
                prev: points[bI],
                next: tangentCoords[1]
            };
            const pinkDetail = (0, $ahQvm.generateAngles)(pinkP, clockwise);
            const alternatifParams = {
                startRadian: pinkDetail.startRadian,
                endRadian: pinkDetail.endRadian,
                degree: angleParams[pI].degree,
                points: pinkP
            };
            (0, $c6d8c04060cd5dd9$export$73935091fa556468)(this.circumAnglePink, angleParams[pI], clockwise);
            (0, $c6d8c04060cd5dd9$export$73935091fa556468)(this.alternativeAnglePink, alternatifParams, true);
        }
    }
    generateAngleParams(points, sI, clockwise) {
        const anglePoints = (0, $ba0ab9ea16a15b58$export$5f61282e9abe72d5)(points);
        const params = anglePoints.map((obj)=>{
            const angles = (0, $ahQvm.generateAngles)(obj, clockwise);
            return {
                points: obj,
                startRadian: angles.startRadian,
                endRadian: angles.endRadian,
                degree: angles.degree
            };
        });
        if (!(0, $1fce1050ac5b8010$export$102b20725d4d2263)(this.currPoints, points)) {
            this.currPoints = points;
            const otherIndex = [
                0,
                1,
                2
            ].filter((i)=>i != sI);
            const twoDegree = params[otherIndex[0]].degree + params[otherIndex[1]].degree;
            params[sI].degree = 180 - twoDegree;
            this.currDegrees = params.map((p)=>p.degree);
        } else params.forEach((param, pI)=>param.degree = this.currDegrees[pI]);
        return params;
    }
}



var $fbGgL = parcelRequire("fbGgL");
class $89e1aa004606d8f1$export$2e2bcd8739ae039 extends (0, $fbGgL.default) {
    constructor(cCoord){
        super(cCoord, [
            "A",
            "B",
            "C"
        ]);
    }
}



var $cbvsj = parcelRequire("cbvsj");


const $3b67a35a07c67d2a$var$SliderGen = [
    {
        head: "move tangent point",
        colors: {
            bgColor: 0xB5A1FF,
            barColor: 0x000000,
            buttonColor: 0xB5A1FF
        },
        onUpdate: (v)=>(0, $f3fd8d4ca6003f65$export$5087227eb54526).emit((0, $f3fd8d4ca6003f65$export$cb883390c27ec6dd).moveTangentPoint, v - 100)
    },
    {
        head: "rotate triangle",
        colors: {
            bgColor: 0xBFBFBF,
            barColor: 0x000000,
            buttonColor: 0x000000
        },
        onUpdate: (v)=>(0, $f3fd8d4ca6003f65$export$5087227eb54526).emit((0, $f3fd8d4ca6003f65$export$cb883390c27ec6dd).moveAllPoints, v - 100)
    }
];
class $3b67a35a07c67d2a$export$2e2bcd8739ae039 extends (0, $cbvsj.default) {
    constructor(){
        super($3b67a35a07c67d2a$var$SliderGen, (0, $60b5c7ab3382b5f8$export$186dbbe504e85fe1), (0, $60b5c7ab3382b5f8$export$75f2cc8245aafe09));
    }
} /*
export default class SliderManager {
  Game = Game.getInstance();
  PointManager = PointManager.getInstance();
  EventBus = EventBus;

  moveTangentPoint: BaseSlider;
  rotateTriangle: BaseSlider;

  private dim = this.Game.getDim();
  constructor() {
    this.addSliders();
  }

  handleEnd = () => {
    this.EventBus.emit(EnumEventBus.setRefPoints);
    setTimeout(() => [this.moveTangentPoint, this.rotateTriangle].forEach(s => s.Slider.value = 100), 100);
  };
  getSliders = () => [this.moveTangentPoint, this.rotateTriangle];

  addSliders() {
    const sCoord = getSliderCoords(this.dim);
    this.addMoveTangentPoint(sCoord[0]);
    this.addRotateTriangle(sCoord[1]);
  }
  addMoveTangentPoint(coord: Coord) {
    this.moveTangentPoint = addMoveTangentPointSlider(coord, () => this.handleEnd(), (v: number) => {
      this.EventBus.emit(EnumEventBus.moveTangentPoint, v - 100);
    })
  }
  addRotateTriangle(coord: Coord) {
    this.rotateTriangle = addRotateTriangleSlider(coord, () => this.handleEnd(), (v: number) => {
      this.EventBus.emit(EnumEventBus.moveAllPoints, v - 100);
    })
  }
  setAllVisible(v: boolean) {
    this.moveTangentPoint.visible = v;
    this.rotateTriangle.visible = v;
  }
}*/ 



var $83ZZo = parcelRequire("83ZZo");

var $9e8jK = parcelRequire("9e8jK");


class $4d206c6b567c2f19$export$2e2bcd8739ae039 extends $83ZZo.Graphics {
    constructor(index){
        super(), this.Layers = (0, $9e8jK.default).getInstance(), this.EventBus = (0, $f3fd8d4ca6003f65$export$5087227eb54526), this.fillColor = (0, $60b5c7ab3382b5f8$export$321ead0620a8fedc)[0], this.strokeColor = (0, $60b5c7ab3382b5f8$export$321ead0620a8fedc)[1], this.addToLayer = ()=>this.Layers.UI.addChild(this);
        this.index = index;
        this.addInteractivity();
        this.addToLayer();
    }
    addInteractivity() {
        const setSltdTPIndex = ()=>this.EventBus.emit((0, $f3fd8d4ca6003f65$export$cb883390c27ec6dd).setSltdTPIndex, this.index);
        this.interactive = true;
        this.cursor = "pointer";
        this.on("mousedown", ()=>setSltdTPIndex());
        this.on("touchstart", ()=>setSltdTPIndex());
    }
    draw(coord, selected) {
        const r = 14;
        const strokeW = 3;
        this.clear().circle(coord.x, coord.y, r + (selected ? strokeW / 2 : 0));
        selected ? this.fill(this.fillColor) : this.fill(0xFFFFFF).stroke({
            color: this.strokeColor,
            width: strokeW
        });
    }
}


class $0363e186aa615c23$export$2e2bcd8739ae039 {
    constructor(){
        this.triangle = Array(3).fill(null).map((_, index)=>new (0, $4d206c6b567c2f19$export$2e2bcd8739ae039)(index));
        this.setAllVisible = (status)=>this.triangle.forEach((b)=>{
                setTimeout(()=>b.visible = status, status ? 350 : 0);
            });
    }
    draw(coords, sltdTPIndex) {
        this.triangle.forEach((button, bI)=>button.draw(coords[bI], bI == sltdTPIndex));
    }
}




async function $c26ccbccf9a7a804$export$792f2314b3a6e2b5(context, onComp) {
    const { circle: circle, PointManager: PointManager, LineManager: LineManager, AngleManager: AngleManager, PointTagManager: PointTagManager, TangentRatioButtonManager: TangentRatioButtonManager, SliderManager: SliderManager, cCoord: cCoord } = context;
    [
        PointManager,
        PointTagManager,
        AngleManager,
        LineManager,
        TangentRatioButtonManager,
        SliderManager
    ].forEach((manager)=>manager.setAllVisible(false));
    const sltdTPIndex = PointManager.getSltdTPointIndex();
    const PointsCoord = PointManager.getRedPointsCoord();
    const TPointsCoord = PointManager.getTangentCoords();
    const Points = PointManager.getRedPoints();
    circle.draw({
        radius: circle.radius,
        radians: Array(3).fill((0, $60b5c7ab3382b5f8$export$2bf7a7762037fddc)[0] - 2 * Math.PI)
    });
    await (0, $b990f86cfa82e252$export$7e0882271c304db0)(circle, (0, $60b5c7ab3382b5f8$export$2bf7a7762037fddc)[0], 0, true, cCoord);
    await (0, $b990f86cfa82e252$export$720cbfe21b054bd1)(LineManager.triangle[0], PointsCoord[0], PointsCoord[1]);
    await (0, $b990f86cfa82e252$export$720cbfe21b054bd1)(LineManager.triangle[1], PointsCoord[1], PointsCoord[2]);
    await (0, $b990f86cfa82e252$export$720cbfe21b054bd1)(LineManager.triangle[2], PointsCoord[2], PointsCoord[0]);
    await (0, $b990f86cfa82e252$export$720cbfe21b054bd1)(LineManager.tangent, TPointsCoord[0], TPointsCoord[1]);
    circle.radians = Array(3).fill((0, $60b5c7ab3382b5f8$export$2bf7a7762037fddc)[0]);
    await (0, $b990f86cfa82e252$export$7e0882271c304db0)(circle, (0, $60b5c7ab3382b5f8$export$2bf7a7762037fddc)[1], 2, false, cCoord);
    LineManager.setIsShowSecondSegment(false);
    LineManager.draw(PointsCoord, TPointsCoord, sltdTPIndex);
    (0, $b990f86cfa82e252$export$2707a00551b9d1cc)(AngleManager.circumAnglePink, "p");
    await (0, $b990f86cfa82e252$export$2707a00551b9d1cc)(AngleManager.alternativeAnglePink, "p");
    const CCOLORS = [
        (0, $60b5c7ab3382b5f8$export$9c42f2d310db4e52)[2],
        (0, $60b5c7ab3382b5f8$export$9c42f2d310db4e52)[1],
        (0, $60b5c7ab3382b5f8$export$9c42f2d310db4e52)[2]
    ];
    circle.setColors(CCOLORS);
    await (0, $b990f86cfa82e252$export$6927aa2d8fee9fc5)((0, $60b5c7ab3382b5f8$export$2bf7a7762037fddc)[2], (0, $60b5c7ab3382b5f8$export$2bf7a7762037fddc)[2] + Math.PI / 8, (radian)=>PointManager.setRadian([
            {
                pTag: Points[2].tag,
                radian: radian
            }
        ]));
    await (0, $b990f86cfa82e252$export$6927aa2d8fee9fc5)((0, $60b5c7ab3382b5f8$export$2bf7a7762037fddc)[2] + Math.PI / 8, (0, $60b5c7ab3382b5f8$export$2bf7a7762037fddc)[2], (radian)=>PointManager.setRadian([
            {
                pTag: Points[2].tag,
                radian: radian
            }
        ]));
    circle.radians = [
        (0, $60b5c7ab3382b5f8$export$2bf7a7762037fddc)[0],
        (0, $60b5c7ab3382b5f8$export$2bf7a7762037fddc)[0],
        (0, $60b5c7ab3382b5f8$export$2bf7a7762037fddc)[1]
    ];
    circle.setColors((0, $60b5c7ab3382b5f8$export$9c42f2d310db4e52));
    await (0, $b990f86cfa82e252$export$7e0882271c304db0)(circle, Math.PI - (0, $60b5c7ab3382b5f8$export$2bf7a7762037fddc)[1], 0, false, cCoord);
    LineManager.setIsShowSecondSegment(true);
    LineManager.draw(PointsCoord, TPointsCoord, sltdTPIndex);
    (0, $b990f86cfa82e252$export$2707a00551b9d1cc)(AngleManager.circumAngleBlue, "b");
    await (0, $b990f86cfa82e252$export$2707a00551b9d1cc)(AngleManager.alternativeAngleBlue, "b");
    await (0, $b990f86cfa82e252$export$6927aa2d8fee9fc5)((0, $60b5c7ab3382b5f8$export$2bf7a7762037fddc)[1], (0, $60b5c7ab3382b5f8$export$2bf7a7762037fddc)[1] + Math.PI / 8, (radian)=>PointManager.setRadian([
            {
                pTag: Points[1].tag,
                radian: radian
            }
        ]));
    await (0, $b990f86cfa82e252$export$6927aa2d8fee9fc5)((0, $60b5c7ab3382b5f8$export$2bf7a7762037fddc)[1] + Math.PI / 8, (0, $60b5c7ab3382b5f8$export$2bf7a7762037fddc)[1], (radian)=>PointManager.setRadian([
            {
                pTag: Points[1].tag,
                radian: radian
            }
        ]));
    [
        PointManager,
        PointTagManager,
        TangentRatioButtonManager,
        SliderManager
    ].forEach((manager)=>manager.setAllVisible(true));
    onComp();
}



var $3JQTS = parcelRequire("3JQTS");
class $428208072ff884ba$export$2e2bcd8739ae039 {
    constructor(PointManager, PointTagManager, AngleManager, LineManager, TangentRatioButtonManager, SliderManager, circle, cCoord){
        this.PointManager = PointManager;
        this.PointTagManager = PointTagManager;
        this.AngleManager = AngleManager;
        this.LineManager = LineManager;
        this.TangentRatioButtonManager = TangentRatioButtonManager;
        this.SliderManager = SliderManager;
        this.circle = circle;
        this.cCoord = cCoord;
        this.RootEventBus = (0, $3JQTS.RootEventBus);
        this.AngleManager.draw(PointManager.getRedPoints(), PointManager.getTangentCoords(), 0, true);
    }
    runAnimations() {
        this.RootEventBus.emit((0, $3JQTS.EnumRootEventBus).startIntroAnim);
        (0, $c26ccbccf9a7a804$export$792f2314b3a6e2b5)({
            PointManager: this.PointManager,
            PointTagManager: this.PointTagManager,
            AngleManager: this.AngleManager,
            LineManager: this.LineManager,
            TangentRatioButtonManager: this.TangentRatioButtonManager,
            SliderManager: this.SliderManager,
            circle: this.circle,
            cCoord: this.cCoord
        }, ()=>{
            this.RootEventBus.emit((0, $3JQTS.EnumRootEventBus).getCircleCoord, {
                x: this.circle.x,
                y: this.circle.y
            });
            this.RootEventBus.emit((0, $3JQTS.EnumRootEventBus).completedIntroAnim);
        });
    }
}



var $jG160 = parcelRequire("jG160");

var $dF6vz = parcelRequire("dF6vz");

var $83ZZo = parcelRequire("83ZZo");

var $9e8jK = parcelRequire("9e8jK");

var $3JQTS = parcelRequire("3JQTS");


var $2Msgp = parcelRequire("2Msgp");

var $6vXZw = parcelRequire("6vXZw");

var $hL4lC = parcelRequire("hL4lC");

var $83ZZo = parcelRequire("83ZZo");

var $ge12w = parcelRequire("ge12w");
function $435b5bc73e725620$export$2e2bcd8739ae039(path, bounds, anchor) {
    const texture = (0, $ge12w.default).getTexture(path);
    const sprite = new $83ZZo.Sprite(texture);
    sprite.x = -1000;
    sprite.y = -1000;
    Object.assign(sprite, bounds);
    sprite.scaleValue = bounds.scale;
    sprite.anchor.set(anchor.x, anchor.y);
    return sprite;
}


function $da9fdf8523182fe7$export$2e2bcd8739ae039(point1, point2) {
    return Math.sqrt(Math.pow(point1.x - point2.x, 2) + Math.pow(point1.y - point2.y, 2));
}


const $9a9d7292b43b4fff$var$_scale = 112 / 604;
class $9a9d7292b43b4fff$export$2e2bcd8739ae039 extends $83ZZo.Container {
    constructor(coord){
        super(), this.Layers = (0, $9e8jK.default).getInstance(), this.RootEventBus = (0, $3JQTS.RootEventBus), this.addToLayer = ()=>this.Layers.Bottom.addChild(this), this.addHead = ()=>{
            this.head = (0, $435b5bc73e725620$export$2e2bcd8739ae039)((0, $60b5c7ab3382b5f8$export$a310f85340477585)[0], {
                width: 133,
                height: 138,
                scale: 133 / 489
            }, {
                x: .5,
                y: 1
            });
            this.addChild(this.head);
        }, this.addCorkscrew = ()=>{
            this.corkscrew = (0, $435b5bc73e725620$export$2e2bcd8739ae039)((0, $60b5c7ab3382b5f8$export$a310f85340477585)[2], {
                width: 105,
                height: 661,
                scale: .35
            }, {
                x: .5,
                y: 0
            });
            this.Layers.Info.addChild(this.corkscrew);
        };
        Object.assign(this, coord);
        this.add();
        this.addToLayer();
        this.RootEventBus.on((0, $3JQTS.EnumRootEventBus).startIntroAnim, ()=>this.setVisible(false));
    }
    setVisible(status) {
        [
            this.head,
            this.corkscrew,
            ...this.foot
        ].forEach((QmdPart)=>{
            const scale = QmdPart.scaleValue;
            if (status) new (0, $hL4lC.default)(QmdPart, scale * .5, scale);
            else new (0, $hL4lC.default)(QmdPart, scale, scale * .5, ()=>QmdPart.visible = status);
        });
        if (!status) this.pant.clear();
    }
    add() {
        this.addPant();
        this.addHead();
        this.addFoot();
        this.addCorkscrew();
    }
    addFoot() {
        this.foot = Array(2).fill(null).map((_, fI)=>{
            const scale = 112 / 604 * (fI == 0 ? 1 : -1);
            const feet = (0, $435b5bc73e725620$export$2e2bcd8739ae039)((0, $60b5c7ab3382b5f8$export$a310f85340477585)[1], {
                width: 112,
                height: 77,
                scale: scale
            }, {
                x: .85,
                y: 0
            });
            feet.scale.set(scale, scale);
            this.addChild(feet);
            return feet;
        });
    }
    addPant() {
        this.pant = new $83ZZo.Graphics();
        this.addChild(this.pant);
    }
    drawPant(sltdTPIndex, pIndex, radius, radians, clockwise) {
        const points = (0, $2Msgp.default)({
            x: 0,
            y: 0
        }, radians, radius);
        const rs = clockwise ? [
            radians[sltdTPIndex],
            radians[pIndex]
        ] : [
            radians[pIndex],
            radians[sltdTPIndex]
        ];
        this.pant.clear().moveTo(points[sltdTPIndex].x, points[sltdTPIndex].y).lineTo(points[pIndex].x, points[pIndex].y).arc(0, 0, radius, rs[0], rs[1]).fill(0xF4AF74);
    }
    updateCoord(sltdTPIndex, radians, radius, clockwise) {
        const prevIndex = sltdTPIndex != 0 ? sltdTPIndex - 1 : radians.length - 1;
        const nextIndex = sltdTPIndex != radians.length - 1 ? sltdTPIndex + 1 : 0;
        const points = (0, $2Msgp.default)({
            x: 0,
            y: 0
        }, radians, radius + 25);
        const corkPoint = {
            x: this.x + Math.cos(radians[sltdTPIndex]) * (radius - 30),
            y: this.y + Math.sin(radians[sltdTPIndex]) * (radius - 30)
        };
        Object.assign(this.foot[0], points[sltdTPIndex]);
        Object.assign(this.foot[1], points[prevIndex]);
        Object.assign(this.head, points[nextIndex]);
        Object.assign(this.corkscrew, corkPoint);
        const footScale = clockwise ? -$9a9d7292b43b4fff$var$_scale : $9a9d7292b43b4fff$var$_scale;
        this.foot[0].rotation = radians[sltdTPIndex] - Math.PI / 2;
        this.foot[0].scale.set(footScale, Math.abs(footScale));
        this.foot[1].rotation = radians[prevIndex] - Math.PI / 2;
        this.foot[1].scale.set(-footScale, Math.abs(footScale));
        const corkRadian = (0, $6vXZw.default)(points[nextIndex], points[sltdTPIndex]);
        this.head.rotation = radians[nextIndex] + Math.PI / 2;
        this.corkscrew.rotation = corkRadian + Math.PI / 2;
        const distance = (0, $da9fdf8523182fe7$export$2e2bcd8739ae039)(points[sltdTPIndex], points[nextIndex]);
        this.corkscrew.scale.set(this.corkscrew.scaleValue, this.corkscrew.scaleValue * (distance < 365 ? distance / 365 : 1));
        this.drawPant(sltdTPIndex, prevIndex, radius, radians, clockwise);
    }
}



var $d55ji = parcelRequire("d55ji");

var $l5XQj = parcelRequire("l5XQj");

var $3JQTS = parcelRequire("3JQTS");


const $8d931e81101dc6c7$var$ButtonStyle = {
    width: 280,
    height: 120,
    wordWrapWidth: 160,
    defaultColor: 0xCECECE,
    hoverColor: 0xDEDEDE,
    pressedColor: 0xC5C5C5,
    borderColor: 0x111111,
    titleColor: 0x111111,
    titleFontSize: 28,
    borderRadius: 22
};
class $8d931e81101dc6c7$export$2e2bcd8739ae039 extends (0, $l5XQj.default) {
    constructor(){
        super("Generate Random Triangle", $8d931e81101dc6c7$var$ButtonStyle, ()=>this.createRandomTriangle()), this.Game = (0, $d55ji.default).getInstance(), this.RootEventBus = (0, $3JQTS.RootEventBus), this.EventBus = (0, $f3fd8d4ca6003f65$export$5087227eb54526), this.createRandomTriangle = ()=>this.EventBus.emit((0, $f3fd8d4ca6003f65$export$cb883390c27ec6dd).genRndmTriangle), this.setVisible = (v)=>this.visible = v;
        this.addCoord();
        this.RootEventBus.on((0, $3JQTS.EnumRootEventBus).startIntroAnim, ()=>this.setVisible(false));
        this.RootEventBus.on((0, $3JQTS.EnumRootEventBus).completedIntroAnim, ()=>this.setVisible(true));
    }
    addCoord() {
        const dim = this.Game.getDim();
        if (dim.WIDTH > dim.HEIGHT) {
            this.x = (0, $60b5c7ab3382b5f8$export$1312ecbb29a79419).x;
            this.y = (0, $60b5c7ab3382b5f8$export$1312ecbb29a79419).y;
            return;
        }
        this.x = dim.WIDTH / 2 - 200;
        this.y = dim.HEIGHT / 2 + 420;
    }
}



var $83ZZo = parcelRequire("83ZZo");

var $d55ji = parcelRequire("d55ji");

var $9e8jK = parcelRequire("9e8jK");

var $hvh3T = parcelRequire("hvh3T");


var $3JQTS = parcelRequire("3JQTS");

class $f028a13b66817244$export$2e2bcd8739ae039 extends $83ZZo.Container {
    constructor(){
        super(), this.Game = (0, $d55ji.default).getInstance(), this.Layers = (0, $9e8jK.default).getInstance(), this.RootEventBus = (0, $3JQTS.RootEventBus), this.EventBus = (0, $f3fd8d4ca6003f65$export$5087227eb54526), this.addToLayer = ()=>this.Layers.UI.addChild(this), this.handleFunc = (isActive)=>this.EventBus.emit((0, $f3fd8d4ca6003f65$export$cb883390c27ec6dd).quasimodoMode, isActive), this.setVisible = (v)=>this.visible = v;
        const coord = this.getCoord();
        Object.assign(this, coord);
        this.addSwitcher();
        this.addHeader();
        this.addToLayer();
        this.RootEventBus.on((0, $3JQTS.EnumRootEventBus).startIntroAnim, ()=>this.setVisible(false));
        this.RootEventBus.on((0, $3JQTS.EnumRootEventBus).completedIntroAnim, ()=>this.setVisible(true));
    }
    addHeader() {
        const header = new $83ZZo.Text({
            text: "Quasimodo Mode: "
        });
        header.style.wordWrap = true;
        header.style.wordWrapWidth = 250;
        header.anchor.set(.5);
        header.y = -54;
        this.addChild(header);
    }
    addSwitcher() {
        const dim = this.Game.getDim();
        this.Switcher = new (0, $hvh3T.default)(0x55E39F, this.handleFunc, true);
        this.Switcher.scale.set(dim.WIDTH > dim.HEIGHT ? 1.3 : 1.9);
        this.addChild(this.Switcher);
    }
    getCoord() {
        const dim = this.Game.getDim();
        if (dim.WIDTH > dim.HEIGHT) return 0, $60b5c7ab3382b5f8$export$c6fbe3a520aa2995;
        return {
            x: dim.WIDTH / 2 - 200,
            y: dim.HEIGHT / 2 + 630
        };
    }
}




var $3JQTS = parcelRequire("3JQTS");
function $039173b9be2c8dd5$export$8bcf5a95f698e8c4(radians, isbtw) {
    const r = [
        ...radians
    ];
    return isbtw ? [
        r[2],
        r[1],
        r[0]
    ] : r;
}


function $7eae3a08914c303f$export$e6ec757508d1274(sI, radians, radius, isbtw) {
    const rL = radians.length;
    const endRadian = radians[sI != 0 ? sI - 1 : rL - 1];
    const middleRadian = radians[sI];
    const startRadian = radians[sI != rL - 1 ? sI + 1 : 0];
    const _radians = [
        endRadian,
        middleRadian,
        startRadian
    ];
    const Radians = (0, $039173b9be2c8dd5$export$8bcf5a95f698e8c4)(_radians, isbtw);
    const details = {
        radians: Radians,
        radius: radius
    };
    return details;
}




var $2Msgp = parcelRequire("2Msgp");

var $2qYgo = parcelRequire("2qYgo");

var $6DjBJ = parcelRequire("6DjBJ");

var $cDZM5 = parcelRequire("cDZM5");

const $c6b3d8cc51750301$var$text = "Select the points to swap the tangent";
const $c6b3d8cc51750301$var$color = (0, $60b5c7ab3382b5f8$export$321ead0620a8fedc)[0];
class $c6b3d8cc51750301$export$2e2bcd8739ae039 extends (0, $cDZM5.default) {
    constructor(){
        super($c6b3d8cc51750301$var$text, $c6b3d8cc51750301$var$color, (0, $60b5c7ab3382b5f8$export$e7d0c45026efed5d), 40);
    }
}


function $3b11c9ab9bd3cf1c$export$2e2bcd8739ae039(CIRCLE_COLORS, isbtw, quasimodoMode) {
    const pinkColor = !quasimodoMode ? CIRCLE_COLORS[1] : 0x000000;
    const colors = [
        CIRCLE_COLORS[0],
        pinkColor,
        CIRCLE_COLORS[2]
    ];
    return isbtw ? [
        colors[1],
        colors[0],
        colors[2]
    ] : colors;
}


class $0f5790840b45b8f2$export$2e2bcd8739ae039 {
    constructor(){
        this.Game = (0, $d55ji.default).getInstance();
        this.RootEventBus = (0, $3JQTS.RootEventBus);
        this.EventBus = (0, $f3fd8d4ca6003f65$export$5087227eb54526);
        this.completedIntroAnim = false;
        this.cCoord = this.isPortail();
        this.circle = new (0, $jG160.default)(this.cCoord, (0, $60b5c7ab3382b5f8$export$2bf7a7762037fddc), (0, $60b5c7ab3382b5f8$export$9c42f2d310db4e52));
        this.PointManager = new (0, $dc934d77cbe07438$export$2e2bcd8739ae039)(this.cCoord);
        this.PointTagManager = new (0, $89e1aa004606d8f1$export$2e2bcd8739ae039)(this.cCoord);
        this.TangentRatioButtonManager = new (0, $0363e186aa615c23$export$2e2bcd8739ae039)();
        this.AngleManager = new (0, $fb830ff0290f258a$export$2e2bcd8739ae039)();
        this.LineManager = new (0, $69464e1b4eaec9ae$export$2e2bcd8739ae039)([
            (0, $60b5c7ab3382b5f8$export$301500ed3a742f63)[1],
            (0, $60b5c7ab3382b5f8$export$7a003cdef7722780)[1]
        ]);
        this.SliderManager = new (0, $3b67a35a07c67d2a$export$2e2bcd8739ae039)();
        this.Quasimodo = new (0, $9a9d7292b43b4fff$export$2e2bcd8739ae039)(this.cCoord);
        this.InfoSlider = new (0, $dF6vz.default)((0, $60b5c7ab3382b5f8$export$840ec2322406bfdd), (0, $60b5c7ab3382b5f8$export$4697ad01a4a84996));
        this.genRandomTriangle = new (0, $8d931e81101dc6c7$export$2e2bcd8739ae039)();
        this.QuasimodoMode = false;
        this.QuasimodoSwitcherModeCon = new (0, $f028a13b66817244$export$2e2bcd8739ae039)();
        this.GuideText = new (0, $6DjBJ.default)({
            x: 100,
            y: 10
        });
        this.GuideTextTangent = new (0, $c6b3d8cc51750301$export$2e2bcd8739ae039)();
        this.IntroAnimationManager = new (0, $428208072ff884ba$export$2e2bcd8739ae039)(this.PointManager, this.PointTagManager, this.AngleManager, this.LineManager, this.TangentRatioButtonManager, this.SliderManager, this.circle, this.cCoord);
        this.genRandomTriangle.setVisible(false);
        this.IntroAnimationManager.runAnimations();
        this.RootEventBus.on((0, $3JQTS.EnumRootEventBus).drawElements, ()=>this.drawElements());
        this.EventBus.on((0, $f3fd8d4ca6003f65$export$cb883390c27ec6dd).quasimodoMode, (v)=>this.setQuasimodoMode(v));
        this.RootEventBus.on((0, $3JQTS.EnumRootEventBus).completedIntroAnim, ()=>this.completedIntroAnim = true);
    }
    isPortail() {
        const dim = this.Game.getDim();
        if (dim.WIDTH > dim.HEIGHT) return 0, $60b5c7ab3382b5f8$export$c7609d9da8d80867;
        return {
            x: dim.WIDTH / 2,
            y: dim.HEIGHT / 2
        };
    }
    setQuasimodoMode(v) {
        this.QuasimodoMode = v;
        [
            this.PointTagManager,
            this.TangentRatioButtonManager
        ].forEach((m)=>m.setAllVisible(!v));
        [
            this.GuideText,
            this.GuideTextTangent
        ].forEach((t)=>t.setVisible(!v));
        this.Quasimodo.setVisible(v);
        this.drawElements();
    }
    drawElements() {
        const points = this.PointManager.getPoints();
        const radians = this.PointManager.getRadians();
        const isbtw = (0, $2qYgo.default)(points[0], points[3], radians[0], radians[1]);
        const radius = this.PointManager.circleRadius;
        const sltdTPIndex = this.PointManager.getSltdTPointIndex();
        const redPointsCoord = this.PointManager.getRedPointsCoord();
        const tangentCoords = this.PointManager.getTangentCoords();
        const circleDetails = (0, $7eae3a08914c303f$export$e6ec757508d1274)(sltdTPIndex, radians, radius, isbtw);
        this.completedIntroAnim && this.circle.setColors((0, $3b11c9ab9bd3cf1c$export$2e2bcd8739ae039)((0, $60b5c7ab3382b5f8$export$9c42f2d310db4e52), isbtw, this.QuasimodoMode));
        this.circle.draw(circleDetails);
        this.LineManager.draw(redPointsCoord, tangentCoords, sltdTPIndex);
        this.AngleManager.draw(redPointsCoord, tangentCoords, sltdTPIndex, !isbtw);
        if (this.QuasimodoMode) this.Quasimodo.updateCoord(sltdTPIndex, radians, radius, isbtw);
        else {
            this.PointTagManager.updateCoord(radians, radius);
            this.TangentRatioButtonManager.draw((0, $2Msgp.default)(this.cCoord, radians, radius + 70), sltdTPIndex);
        }
    }
}



const $679b30b0f75fe8aa$var$canvas = document.querySelector("#canvas");
if ($679b30b0f75fe8aa$var$canvas) window.context = new (0, $d55ji.default)($679b30b0f75fe8aa$var$canvas, (0, $60b5c7ab3382b5f8$export$a310f85340477585), ()=>new (0, $0f5790840b45b8f2$export$2e2bcd8739ae039)());
else console.error("Canvas is not found");


//# sourceMappingURL=index.0490771c.js.map
